<ui-search-overlay-header
  (closed)="closeDialog()"
  (enter)="onEnter($event)"
  (searchText)="onSearchTextChanged($event)"
  [initialSearchText]="initialSearchText()">
</ui-search-overlay-header>

<div class="wrapper-suggestions">
  @if (suggestions().length > 0) {
    <span class="result-count">{{ suggestions().length }} Treffer</span>
  }

  <mat-list class="search-suggestions-list">
    @for (suggestion of suggestions(); track suggestion) {
      <ui-search-suggestion-card
        (clicked)="closeDialog()"
        [suggestion]="suggestion"
        [position]="$index"
      ></ui-search-suggestion-card>
    }
  </mat-list>
</div>
